import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePrevious from 'lib/src/hooks/usePrevious';
import { fetchAllContactUsMessages } from '@actions/contactUsMessages';
import {
    getContactUsMessages,
    getContactUsMessagesFetchError,
    getContactUsMessagesIsDeleting,
    getContactUsMessagesIsFetching,
} from '@selectors/contactUsMessages';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';

const useContactUsMessagesFetch = (): Hook => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchAllContactUsMessages());
    }, [dispatch]);

    const contactUsMessages = useSelector(getContactUsMessages);
    const isFetching = useSelector(getContactUsMessagesIsFetching);
    const fetchError = useSelector(getContactUsMessagesFetchError);
    const isDeleting = useSelector(getContactUsMessagesIsDeleting);
    const wasDeleting = usePrevious(isDeleting);

    useEffect(() => {
        if (!isDeleting && wasDeleting) dispatch(fetchAllContactUsMessages());
    }, [isDeleting, wasDeleting, dispatch]);

    return { contactUsMessages, isFetching, fetchError };
};

interface Hook {
    contactUsMessages: Record<number, ContactUsMessage>;
    isFetching: boolean;
    fetchError: string | null;
}

export default useContactUsMessagesFetch;
